/**
 * Schema definition for Meters Form
 * Defines gas meter, electric meter, consumer board, and stop tap
 */

import { BuiltInFormSchema } from '../types/builtInFormSchema';

export const metersFormSchema: BuiltInFormSchema = {
  formId: 'meters',
  formTitle: 'Meters & Services',
  
  sections: [
    // Section 1: Gas Meter
    {
      id: 'gas_meter',
      title: 'Gas Meter',
      fields: [
        {
          id: 'hasGasMeter',
          type: 'boolean',
          label: 'Does the property have a gas meter?',
          required: true,
          style: 'yes-no'
        },
        {
          id: 'gasMeterLocation',
          type: 'text',
          label: 'Gas Meter Location',
          required: false,
          placeholder: 'Enter location or select from rooms',
          helpText: 'Specify where the gas meter is located',
          conditionalOn: {
            fieldId: 'hasGasMeter',
            value: true
          }
        },
        {
          id: 'gasMeterEarthBonding',
          type: 'photo',
          label: 'Gas Meter Earth Bonding Photos',
          required: false,
          maxPhotos: 999,
          helpText: 'Photos of gas meter and earth bonding',
          conditionalOn: {
            fieldId: 'hasGasMeter',
            value: true
          }
        }
      ]
    },
    
    // Section 2: Electric Meter
    {
      id: 'electric_meter',
      title: 'Electric Meter',
      fields: [
        {
          id: 'hasElectricMeter',
          type: 'boolean',
          label: 'Does the property have an electric meter?',
          required: true,
          style: 'yes-no'
        },
        {
          id: 'electricMeterLocation',
          type: 'text',
          label: 'Electric Meter Location',
          required: false,
          placeholder: 'Enter location or select from rooms',
          helpText: 'Specify where the electric meter is located',
          conditionalOn: {
            fieldId: 'hasElectricMeter',
            value: true
          }
        },
        {
          id: 'electricMeter',
          type: 'photo',
          label: 'Electric Meter Photos',
          required: false,
          maxPhotos: 999,
          helpText: 'Photos of electric meter',
          conditionalOn: {
            fieldId: 'hasElectricMeter',
            value: true
          }
        }
      ]
    },
    
    // Section 3: Consumer Board
    {
      id: 'consumer_board',
      title: 'Consumer Board (Fuse Box)',
      fields: [
        {
          id: 'hasConsumerBoard',
          type: 'boolean',
          label: 'Does the property have a consumer board?',
          required: true,
          style: 'yes-no'
        },
        {
          id: 'consumerBoardLocation',
          type: 'text',
          label: 'Consumer Board Location',
          required: false,
          placeholder: 'Enter location or select from rooms',
          helpText: 'Specify where the consumer board/fuse box is located',
          conditionalOn: {
            fieldId: 'hasConsumerBoard',
            value: true
          }
        },
        {
          id: 'consumerBoard',
          type: 'photo',
          label: 'Consumer Board Photos',
          required: false,
          maxPhotos: 999,
          helpText: 'Photos of consumer board/fuse box',
          conditionalOn: {
            fieldId: 'hasConsumerBoard',
            value: true
          }
        }
      ]
    },
    
    // Section 4: Stop Tap
    {
      id: 'stop_tap',
      title: 'Stop Tap (Water Shut-off)',
      fields: [
        {
          id: 'hasStopTap',
          type: 'boolean',
          label: 'Does the property have a stop tap?',
          required: true,
          style: 'yes-no'
        },
        {
          id: 'stopTapLocation',
          type: 'text',
          label: 'Stop Tap Location',
          required: false,
          placeholder: 'Enter location or select from rooms',
          helpText: 'Specify where the water stop tap is located',
          conditionalOn: {
            fieldId: 'hasStopTap',
            value: true
          }
        },
        {
          id: 'stopTap',
          type: 'photo',
          label: 'Stop Tap Photos',
          required: false,
          maxPhotos: 999,
          helpText: 'Photos of water stop tap',
          conditionalOn: {
            fieldId: 'hasStopTap',
            value: true
          }
        }
      ]
    }
  ]
};
